
import React, { createContext, useReducer, useContext } from "react";
import { withApollo } from '@apollo/react-hoc';
import { message } from 'antd'
import { withRouter } from 'react-router-dom';
import { FormContext } from './context-reducer'
import { AuthContext } from '../../../../../context/authContext';


export const ASSIGN_LOADING = 'ASSIGN_LOADING'


const initialState = {
    assignLoading:false
};


const FormAssignReducer = (state, action)=>{
    switch (action.type) {
        case ASSIGN_LOADING:
            return {...state, assignLoading: action.payload }
        default:
          return state
      }
}


const FormAssignStore = (props) => {
  const authContextComp = useContext(AuthContext);

  const [state, dispatch] = useReducer(FormAssignReducer, initialState);
  const context = useContext(FormContext);

  // let subScriber = 'global';
  // if(authContextComp.data && authContextComp.data != null){
  //   subScriber = authContextComp.data.subscriberId
  // }



  const handleFormAssign=async(checked, record, sId)=>{
    if(checked == true){
      if(record && record != null){
        dispatch({
          type: ASSIGN_LOADING,
          payload: true
        })
        let res = await context.getFormTemplateBySlugValueFun(record.slugValue)
        if(res.data.getFormTemplateBySlugValue != null){
          let res2 = await context.createCopyOfForm(res.data.getFormTemplateBySlugValue, sId)
          if(res2 == true){
            message.success('Form is assigned successfully')
            dispatch({
              type: ASSIGN_LOADING,
              payload: false
            })
          }
        }
      }
    }
  }

  const handleBulkFormAssign=async(formList, sId)=>{
    for(let i = 0; i < formList.length; i++){
      let record = formList[i] 

        if(record && record != null){
          dispatch({
            type: ASSIGN_LOADING,
            payload: true
          })
          let res = await context.getFormTemplateBySlugValueFun(record.slugValue)
          if(res.data.getFormTemplateBySlugValue != null){
            let res2 = await context.createCopyOfForm(res.data.getFormTemplateBySlugValue, sId)
            if(res2 == true){
              message.success('Form assigned successfully')
              dispatch({
                type: ASSIGN_LOADING,
                payload: false
              })
            }
          }
        }

    }
}


  return (
      <FormAssignContext.Provider value={{
          state, 
          handleFormAssign,
          handleBulkFormAssign
          }}>
          {props.children}
      </FormAssignContext.Provider>
  )
};


const FormAssignContext = createContext(initialState);


const FormAssignStoreW = withRouter(withApollo(FormAssignStore))


export {
  FormAssignReducer,
  FormAssignStoreW,
  FormAssignContext
}


